// extracted by mini-css-extract-plugin
export default {"shares-section":"LootboxSharesSection_shares-section__3wuOC","shares-icon":"LootboxSharesSection_shares-icon__gYYmr"};